export const menuItems = [
  {
    id: "waffle_pollo",
    title: "Waffle de Pollo",
    price: "$13.000",
    description: "Relleno de pollo, tocino, queso, lechuga",
    image:
      "https://static.prod-images.emergentagent.com/jobs/245d6bc9-9e93-4e36-88a7-4062f78634d1/images/f32e028725f0abd82d8f1a7d2a9747b79831996ec92b17d64fb3d1b258b0f4aa.png",
    bg: "yellow",
    tag: "Salado",
  },
  {
    id: "waffle_jamon",
    title: "Waffle de Jamón",
    price: "$12.000",
    description: "Waffle de jamón, jamón, queso, lechuga, tomate",
    image:
      "https://static.prod-images.emergentagent.com/jobs/245d6bc9-9e93-4e36-88a7-4062f78634d1/images/f7dcd0461b38ecab0aaa476f9c7fc662fc9095235e533416d58064e4ce121eb0.png",
    bg: "green",
    tag: "Salado",
  },
  {
    id: "waffle_oreo",
    title: "Waffle de Oreo",
    price: "$12.000",
    description:
      "Waffle de base, crema de oreo, trozos de oreo, chocolate, lecherita o arequipe, fruta de preferencia y m&m",
    image:
      "https://static.prod-images.emergentagent.com/jobs/245d6bc9-9e93-4e36-88a7-4062f78634d1/images/ac756d31dd41f8dd8b84551297f35608d7d14bf5f2289c95bdfeef35e1921036.png",
    bg: "cream",
    tag: "Estrella",
  },
  {
    id: "waffle_mani",
    title: "Waffle de Maní con Almendras",
    price: "$10.000",
    description:
      "Waffle recubierto con crema de maní, trozos de almendras y lecherita",
    image:
      "https://static.prod-images.emergentagent.com/jobs/245d6bc9-9e93-4e36-88a7-4062f78634d1/images/a21e9f0bbfc05e25f186060028dba23713e17d039fe6a19f77d321cb327491b8.png",
    bg: "yellow",
    tag: "Nuevo",
  },
  {
    id: "waffle_milo",
    title: "Waffle de Milo",
    price: "$10.000",
    description: "Waffle con crema de Milo, trozos de Milo, base chocolate",
    image:
      "https://static.prod-images.emergentagent.com/jobs/245d6bc9-9e93-4e36-88a7-4062f78634d1/images/a1674bc3b158f9142a69cf871ba96949be744a5d13916e3cd7307c8194e228bd.png",
    bg: "cream",
    tag: "Favorito",
  },
  {
    id: "waffle_fruta",
    title: "Waffle Solo Fruta",
    price: "$11.000",
    description:
      "Waffle con fruta de preferencia (fresa, kiwi, banana), base arequipe, chocolate o lecherita",
    image:
      "https://static.prod-images.emergentagent.com/jobs/245d6bc9-9e93-4e36-88a7-4062f78634d1/images/f381eb52d5eb4fe9b5c8bc65d670f543f238ad88e81fc1e2fc9800464ace5ed7.png",
    bg: "green",
    tag: "Saludable",
  },
];

export const HERO_WAFFLE = "/hero-waffle.png";

export const PHONE = "3138703174";
export const PHONE_INTL = "573138703174";
export const INSTAGRAM = "buffysdulce";

export const buildWhatsAppLink = (productTitle) => {
  const base = `https://wa.me/${PHONE_INTL}`;
  if (!productTitle) {
    return `${base}?text=${encodeURIComponent(
      "¡Hola Buffy's! Quiero hacer un pedido."
    )}`;
  }
  const msg = `¡Hola Buffy's! 🧇 Quiero pedir un *${productTitle}*. ¿Está disponible?`;
  return `${base}?text=${encodeURIComponent(msg)}`;
};
